import "react-tooltip/dist/react-tooltip.css";
import "./Tooltip.scss";

import type { ReactNode } from "react";
import React, { useId } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";

export interface TooltipProps {
  children: ReactNode;
  content: string;
  id?: string;
  place?: "top" | "right" | "bottom" | "left";
  className?: string;
  delayShow?: number;
  delayHide?: number;
  variant?: "dark" | "success" | "warning" | "error" | "info";
  anchorStyle?: "inline-block" | "block-full";
  html?: boolean; // allow HTML content for multiline tooltips
  offset?: number; // offset in pixels
  positionStrategy?: "absolute" | "fixed"; // positioning strategy
}

export const Tooltip: React.FC<TooltipProps> = ({
  children,
  content,
  id,
  place = "top",
  className = "",
  delayShow = 0,
  delayHide = 0,
  variant = "dark",
  anchorStyle = "inline-block",
  html = false,
  offset = 10,
  positionStrategy = "absolute",
}) => {
  const generatedId = useId();
  const tooltipId = id || `tooltip-${generatedId}`;

  const tooltipProps = html ? { html: content } : { content };

  return (
    <>
      <div
        data-tooltip-id={tooltipId}
        className={`tooltip-anchor tooltip-anchor--${anchorStyle} ${className}`}
      >
        {children}
      </div>
      <ReactTooltip
        id={tooltipId}
        place={place}
        {...tooltipProps}
        className={`custom-tooltip ${variant}`}
        delayShow={delayShow}
        delayHide={delayHide}
        offset={offset}
        positionStrategy={positionStrategy}
      />
    </>
  );
};

export default Tooltip;
